import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Forgot from "../../components/Forgot";
// import Token from "../../components/Forgot/token";
import Password from "../../components/Forgot/password";

import { IoChevronBackOutline } from "react-icons/io5";

export default function ForgotPage() {
    const params = useParams();
    const navigate = useNavigate();

    const [step, setStep] = useState(1);
    const [token, setToken] = useState("");
    const [email, setEmail] = useState("");

    useEffect(() => {
        if (params?.token) {
            setStep(3);
            setToken(params.token);
        }
    }, [params]);

    return (
        <div className="d-flex mw-100 vh-100 align-items-center justify-content-center" style={{ backgroundColor: "var(--main-background-light)" }}>
            <div className="container-sm" style={{ width: 888 }}>
                <div className="row shadow" style={{ border: "1px solid #f5f5f5" }}>
                    <div className="col-12 col-md-6 d-none d-md-block" style={{ backgroundColor: "var(--main-background-color)" }}>
                        <div className="container-text-to-image">
                            <img
                                src={`${process.env.PUBLIC_URL}/assets/undraws/undraw_login_re_4vu2.svg`}
                                alt="undraw_login_re_4vu2"
                                style={{ width: "100%", minHeight: 600 }}
                            />

                            <div className="text-to-image-top-left">
                                <div style={{ marginLeft: -28, marginTop: 50 }}>
                                    <span className="style-back-page" onClick={() => navigate("/")}>
                                        <IoChevronBackOutline />
                                        <span className="mx-2">กลับ</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6" style={{ backgroundColor: "#ffffff" }}>
                        <div className="p-5">
                            {step === 1 && <Forgot email={email} setEmail={setEmail} navigate={navigate} setStep={setStep} />}
                            {/* {step === 2 && (
                                <Token email={email} token={token} setToken={setToken} navigate={navigate} setStep={setStep} />
                            )} */}
                            {step === 3 && <Password email={email} token={token} navigate={navigate} setStep={setStep} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
